import { parseDecimal, payout, kelly, doubleChance } from './calculator.js';
import './guide-contents.js';
import './back-to-top.js';
import './partner-offers.js';

document.documentElement.classList.add('js-enabled');

const menuToggle = document.querySelector('.menu-toggle');
const nav = document.querySelector('.site-nav');
function closeMenu() {
  menuToggle?.setAttribute('aria-expanded', 'false');
  nav?.classList.remove('is-open');
}
menuToggle?.addEventListener('click', () => {
  const open = menuToggle.getAttribute('aria-expanded') !== 'true';
  menuToggle.setAttribute('aria-expanded', String(open));
  nav.classList.toggle('is-open', open);
});
document.addEventListener('keydown', (event) => {
  if (
    event.key === 'Escape' &&
    menuToggle?.getAttribute('aria-expanded') === 'true'
  ) {
    closeMenu();
    menuToggle.focus();
  }
});
document.addEventListener('click', (event) => {
  if (!event.target.closest('.site-header')) closeMenu();
});
matchMedia('(min-width: 1001px)').addEventListener('change', closeMenu);

const directory = document.querySelector('[data-directory]');
if (directory) {
  let category = 'all';
  const search = directory.querySelector('[data-search]');
  const cards = [...directory.querySelectorAll('[data-guide]')];
  const buttons = [...directory.querySelectorAll('[data-filter]')];
  const update = () => {
    const query = search.value.toLocaleLowerCase('es-AR').trim();
    let count = 0;
    for (const card of cards) {
      const visible =
        (category === 'all' || card.dataset.category === category) &&
        card.textContent.toLocaleLowerCase('es-AR').includes(query);
      card.hidden = !visible;
      if (visible) count++;
    }
    directory.querySelector(
      '[data-filter-status]'
    ).textContent = `Artículos encontrados: ${count}`;
    directory.querySelector('[data-empty]').hidden = count > 0;
  };
  for (const button of buttons)
    button.addEventListener('click', () => {
      category = button.dataset.filter;
      buttons.forEach((item) =>
        item.setAttribute('aria-pressed', String(item === button))
      );
      update();
    });
  search.addEventListener('input', update);
  directory
    .querySelector('[data-clear-filters]')
    .addEventListener('click', () => {
      search.value = '';
      buttons[0].click();
      search.focus();
    });
}

const calculator = document.querySelector('[data-calculator]');
if (calculator) {
  const tabs = [...calculator.querySelectorAll('[data-tab]')];
  const selectTab = (tab) => {
    for (const item of tabs) {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    }
    for (const panel of calculator.querySelectorAll('[data-panel]'))
      panel.hidden = panel.dataset.panel !== tab.dataset.tab;
  };
  for (const [index, tab] of tabs.entries()) {
    tab.addEventListener('click', () => selectTab(tab));
    tab.addEventListener('keydown', (event) => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft')
        next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) {
        event.preventDefault();
        selectTab(tabs[next]);
        tabs[next].focus();
      }
    });
  }
  const format = (value, digits = 2) =>
    new Intl.NumberFormat('es-AR', { maximumFractionDigits: digits }).format(
      value
    );
  for (const form of calculator.querySelectorAll('[data-form]')) {
    const panel = form.closest('[data-panel]');
    const result = panel.querySelector('.calculator-result');
    const error = form.querySelector('[data-error]');
    const run = (showError = true) => {
      try {
        const values = Object.fromEntries(
          [...new FormData(form)].map(([key, value]) => [
            key,
            parseDecimal(value),
          ])
        );
        let data;
        if (form.dataset.form === 'payout')
          data = payout(values.stake, values.odds);
        if (form.dataset.form === 'kelly') {
          data = kelly(
            values.bankroll,
            values.odds,
            values.probability,
            values.fraction
          );
          data.fractionLabel = {
            1: 'Kelly completo',
            0.5: 'Medio Kelly',
            0.25: 'Cuarto Kelly',
          }[values.fraction];
          data.explanation = data.hasEdge
            ? 'Es un resultado del modelo, no un monto recomendado para apostar. Incluso Kelly fraccionado implica riesgo de pérdidas.'
            : 'Con la probabilidad ingresada, el modelo no identifica una ventaja. El monto teórico es 0 ARS.';
        }
        if (form.dataset.form === 'chance')
          data = doubleChance(values.home, values.draw, values.away);
        for (const element of result.querySelectorAll('[data-value]')) {
          const key = element.dataset.value;
          element.textContent =
            typeof data[key] === 'number'
              ? format(
                  data[key],
                  ['oneX', 'xTwo', 'oneTwo'].includes(key) ? 3 : 2
                )
              : data[key];
        }
        error.hidden = true;
        error.textContent = '';
        result.classList.remove('result-invalid');
        result.querySelector('[data-status]').textContent =
          form.dataset.form === 'chance' && data.sum < 100
            ? 'La suma es menor al 100%: verificá que las cuotas pertenezcan a la misma línea y mercado.'
            : '';
      } catch (exception) {
        error.textContent = exception.message;
        error.hidden = !showError;
        result.classList.add('result-invalid');
        result
          .querySelectorAll('[data-value]')
          .forEach((element) => (element.textContent = '—'));
        result.querySelector('[data-status]').textContent =
          'Ingresá datos válidos para calcular.';
      }
    };
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      run();
    });
    form.addEventListener('input', () => run(false));
    form.addEventListener('change', () => run());
    form.querySelector('[data-reset]').addEventListener('click', () => {
      form.reset();
      run();
    });
    run();
  }
}
